import { useContext } from 'react';
import { AlertContext } from './AlertProvider';

const useAlert = () => useContext(AlertContext).alert;
export const useDeletionAlert = () => useContext(AlertContext).alertDelete;

export default useAlert;